import React from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import classes from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <div className="container">
        <div className={classes.top}>
          <span className={classes.brand}>Cryptologics-AI</span>
          <nav className={classes.nav} aria-label="Footer">
            <a href="#/profile/portfolio">Portfolio</a>
            <a href="#/profile/traderform">Autotrader</a>
            <a href="#/profile/orderhistory">Orders</a>
            <a href="#/profile/about">About</a>
          </nav>
        </div>

        <div className={classes.bottom}>
          <span className={classes.contact}>
            <i className="fas fa-envelope" aria-hidden="true"></i>
            <a href="mailto:support@cryptologics-ai.com">support@cryptologics-ai.com</a>
          </span>
          <span className={classes.contact}>
            <i className="fab fa-discord" aria-hidden="true"></i>
            <a href="https://discord.gg/b5x2HgFsS" target="_blank" rel="noopener noreferrer">
              Join our Discord
            </a>
          </span>
          <span className={classes.copy}>
            © {new Date().getFullYear()} Cryptologics-AI LLC
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;